import {componentLoader, Loadable} from "@bounce/shared/helpers";
import {lazy} from "react";
import {Navigate, useRoutes} from "react-router-dom";
import {backofficeRoutes} from "./backoffice/backofficeRoutes";
import {urls} from "./urls";

const ErrorPage = Loadable(lazy(() => componentLoader(() => import("../pages/error/ErrorPage"))));

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <Navigate to={urls.backofficeLogin.url} replace />,
    },
    ...backofficeRoutes,
    {path: urls.error.path, element: <ErrorPage />},
    {path: "*", element: <Navigate to={urls.error.url} replace />},
  ]);
}
